export const colors = {
    primary: '#e1b420',
    primarySpark: '#f8d665',
    spark: '#f8d665',
    primaryText: '#ffd652',
    secondary: '#aa814c',
    light: '#faf5f0',
    lightSpark: '#ffebab',
    lightish: '#dcd5c5',
    medium: '#cebfa6',
    dark: '#222',
    palleteGray: '#636262',
    borderShadow: '#faf5f0',
    
    semiDark: 'rgba(34, 34, 34, 0.87)',
    transparentDark: '#222222e8',
    faint: 'rgba(0, 0, 0, 0.2)',
}
